import { getSignalRConnector } from '@/api/signalR/SignalRConnector.ts';
import type { WebapiEndpointBuilder } from '@/api/webapi.ts';
import { buildReceivedEspQuoteReply, startEspStreamMonitor } from '@/store/esp/buildEspQuoteReply.ts';
import type { GetAppState } from '@/store/store.ts';

export type RefreshCashEspBody = {
  dataStreamId: string;
  streamKeys: readonly string[];
};

export const refreshEsp = (builder: WebapiEndpointBuilder) => {
  return builder.mutation<void, RefreshCashEspBody>({
    query: (body) => ({
      url: '/fxSpotFwd/esp/refresh',
      method: 'POST',
      body,
    }),
    async onCacheEntryAdded(params, { cacheDataLoaded, cacheEntryRemoved, dispatch, getState }) {
      await cacheDataLoaded;

      const streamKeys = params.streamKeys;

      const handleReceiveQuoteReplies = streamKeys.map((streamKey) => {
        startEspStreamMonitor(streamKey, dispatch);

        return buildReceivedEspQuoteReply(streamKey, getState as GetAppState, dispatch);
      });

      const signalRConnector = getSignalRConnector();
      for (const handleReceiveQuoteReply of handleReceiveQuoteReplies) {
        signalRConnector.on('ReceiveEspPrice', handleReceiveQuoteReply);
      }

      await cacheEntryRemoved; //  remove automatic cache removed after 1 hour

      for (const handleReceiveQuoteReply of handleReceiveQuoteReplies) {
        signalRConnector.off('ReceiveEspPrice', handleReceiveQuoteReply);
      }
    },
  });
};
